<template>
  <!-- 行业动态 -->
  <div class="page-dynamic">行业动态</div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.page-dynamic {
  
}
</style>

